import { IFollowUpCategory } from "us.collection.followup/interfaces";

export const followUpCategory: IFollowUpCategory = {
  categoryID: -1,
  categoryName: "All",
};
